import { useEffect, useState, useSyncExternalStore } from 'react'
import { subscribeVideo, getVideoIds, getMuted, getRotationMs, buildEmbedSrc } from '../video'

export function YouTubeBackground() {
  const ids = useSyncExternalStore(subscribeVideo, getVideoIds, () => [] as string[])
  const muted = useSyncExternalStore(subscribeVideo, getMuted, () => true)
  const [idx, setIdx] = useState(0)

  // Reset idx si la lista cambia y el índice queda fuera de rango.
  useEffect(() => {
    if (idx >= ids.length) setIdx(0)
  }, [ids.length, idx])

  // Rotación: solo si hay >1 video.
  useEffect(() => {
    if (ids.length < 2) return
    const ms = getRotationMs()
    const t = setInterval(() => setIdx((i) => (i + 1) % ids.length), ms)
    return () => clearInterval(t)
  }, [ids.length])

  if (ids.length === 0) return null

  const current = ids[idx] ?? ids[0]
  const src = buildEmbedSrc(current, muted)

  return (
    <div className="fixed inset-0 pointer-events-none -z-10 overflow-hidden">
      <iframe
        key={current}
        data-testid="youtube-bg"
        src={src}
        title="YouTube background"
        // 16:9 cover: escalar para llenar el viewport sin barras negras.
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[177.78vh] h-screen min-w-full min-h-[56.25vw]"
        allow="autoplay; encrypted-media"
        frameBorder={0}
      />
    </div>
  )
}
